import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TOOLS, SITE_URL } from "@/lib/tools";
import { useSeo } from "@/lib/useSeo";

export default function ToolsIndex() {
  useSeo({
    title: "Oilfield Calculators & Drilling Formulas | RIGCALC",
    description: "Guides to the drilling and well-control formulas rig crews use every day — kill mud weight, kick tolerance, capacities, cementing, torque & drag and more.",
    canonical: `${SITE_URL}/tools`,
  });

  return (
    <div data-testid="tools-index-page" className="max-w-5xl">
      <div className="mono text-[10px] tracking-[0.3em] text-[#f59e0b] mb-3">FIELD GUIDES</div>
      <h1 className="heading text-4xl sm:text-5xl font-bold leading-tight mb-4">Oilfield calculators &amp; formulas</h1>
      <p className="text-[#94a3b8] max-w-2xl mb-10">
        Every formula RIGCALC runs, explained with a worked example. Read the guide, then open the calculator to run your own numbers in Field or Metric units — online or offline.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#334155] border border-[#334155]">
        {TOOLS.map((t, i) => (
          <Link
            key={t.slug}
            to={`/tools/${t.slug}`}
            data-testid={`tool-link-${t.slug}`}
            className="group bg-[#11151c] hover:bg-[#0b0e13] p-6 transition-colors"
          >
            <div className="mono text-[10px] text-[#64748b] mb-2">{String(i + 1).padStart(2, "0")}</div>
            <h2 className="heading text-base md:text-lg font-bold mb-1 group-hover:text-[#f59e0b] transition-colors">{t.name}</h2>
            <p className="text-sm text-[#94a3b8] mb-3">{t.short}</p>
            <span className="inline-flex items-center gap-1 mono text-[10px] tracking-widest uppercase text-[#f59e0b]">
              Read guide <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
